
import Feeds from '@scripts/utilities/feeds.js';

import AjaxService from '../Ajax/index.jsx';


var API = function(categories, limit, query) {
  this.categories = categories;
  this.limit = limit;
  this.query = query;

  this._showLocked = true;
  this._fetchListeners = [];

  this.handleResponse = this.handleResponse.bind(this);

  // add the common "Change Listener" functionality to this API
  Feeds.ChangeListener(this);
};
API.prototype.actionName = 'theme:research-report-feed';
API.prototype.addFetchListener = function(callback) {
  this._fetchListeners.push(callback);
};
API.prototype.removeFetchListener = function(callback) {
  for (var i = 0; i < this._fetchListeners.length; i++) {
    if (this._fetchListeners[i] == callback) {
      this._fetchListeners.splice(i, 1);
      break;
    }
  }
};
API.prototype.showLocked = function(showLocked) {
  this._showLocked = Boolean(showLocked);

  // notify the listeners that things have changed.
  this.notifyChangeListeners();
};
API.prototype.setCategories = function(categories) {
  this.categories = categories;

  this.notifyChangeListeners();
};
API.prototype.updateSearchQuery = function(query) {
  this.query = query;

  this.notifyChangeListeners();
};
API.prototype.fetchPage = function(page) {
  var data = {
    page: page,
    'show-locked': this._showLocked ? '1' : '0'
  };

  if (this.categories.length) {
    data.categories = this.categories.join();
  }
  if (this.query) {
    data.query = encodeURIComponent(this.query);
  }
  if (this.limit) {
    data.limit = this.limit;
  }

  // notify the listeners that we are fetching
  for (var i = 0; i < this._fetchListeners.length; i++) {
    this._fetchListeners[i](true);
  }

  return AjaxService.fetch(this.actionName, data)
    .then(this.handleResponse);
};
API.prototype.handleResponse = function(response) {
  // notify the listeners that we are finished fetching
  for (var i = 0; i < this._fetchListeners.length; i++) {
    this._fetchListeners[i](false);
  }

  if (response) {
    return response;
  } else {
    return [];
  }
};


export default API;


